<form [formGroup]="deepFormGroup">
  <digires-state-indicator [formCtrlName]="fullFormCtrlName" [readOnly]="readOnly" [readOnlyReason]="readOnlyReason" [finModel]="finModel"></digires-state-indicator>
  <mat-form-field *ngIf="textarea && !fixedRowCount" [ngClass]="{'changed':isDirty()}">
    <mat-label>{{placeholder}}</mat-label>
    <label>
      <textarea matInput type="text"
                formControlName="{{formCtrlName}}"
                matTextareaAutosize matAutosizeMinRows="3"
                [required]="required && !readOnly"
                [readonly]="readOnly"
                (change)="onInputChanged()"></textarea>
    </label>
    <div *ngIf="maxLength > 0 && getValue()?.length > 0" class="dw-input-length-limit">
      <code>{{getValue()?.length}}</code> of <code>{{maxLength}}</code> characters
    </div>
    <mat-error *ngIf="error">
      {{error}}
    </mat-error>
    <mat-error *ngFor="let err of getErrorMessages()">
      {{err}}
    </mat-error>
  </mat-form-field>

  <mat-form-field *ngIf="textarea && fixedRowCount" [ngClass]="{'changed':isDirty()}">
    <mat-label>{{placeholder}}</mat-label>
    <label>
      <textarea matInput type="text"
                formControlName="{{formCtrlName}}"
                [rows]="fixedRowCount"
                [required]="required && !readOnly"
                [readonly]="readOnly"
                [ngClass]="{'changed':isDirty()}"
                (change)="onInputChanged()"></textarea>
    </label>
    <div *ngIf="maxLength > 0 && getValue()?.length > 0" class="dw-input-length-limit">
      <code>{{getValue()?.length}}</code> of <code>{{maxLength}}</code> characters
    </div>
    <mat-error *ngIf="error">
      {{error}}
    </mat-error>
    <mat-error *ngFor="let err of getErrorMessages()">
      {{err}}
    </mat-error>
  </mat-form-field>

  <mat-form-field *ngIf="!textarea" [ngClass]="{'changed':isDirty()}">
    <mat-label>{{placeholder}}</mat-label>
    <label>
      <input matInput type="text"
             formControlName="{{formCtrlName}}"
             [required]="required && !readOnly"
             [readonly]="readOnly"
             (change)="onInputChanged()">
    </label>
    <div *ngIf="maxLength > 0 && getValue()?.length > 0" class="dw-input-length-limit">
      <code>{{getValue()?.length}}</code> of <code>{{maxLength}}</code> characters
    </div>
    <mat-error *ngIf="error">
      {{error}}
    </mat-error>
    <mat-error *ngFor="let err of getErrorMessages()">
      {{err}}
    </mat-error>
  </mat-form-field>
  <mat-icon *ngIf="!!tooltip" class="tooltip-icon" matTooltipPosition="above" matTooltip="{{tooltip}}" svgIcon="tooltip"></mat-icon>
  <mat-icon *ngIf="!!finModel" class="warning-triangle" [class.transparent]="!finModel.hasUpload || !finModel.isReadable(fullFormCtrlName) || finModel.isRead(fullFormCtrlName)"
            matTooltip="Note: The value in this field was not populated by the most recent upload of the financial model">
    warning
  </mat-icon>
</form>
